module.exports = __webpack_public_path__ + "static/img/1036_small.d528172.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1036_small.png
// module id = B0hC
// module chunks = 1